import React from 'react';
import { motion } from 'framer-motion';
export function FounderStory() {
  return <section className="section-padding bg-white overflow-hidden" data-id="element-381">
      <div className="container-custom" data-id="element-382">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center max-w-7xl mx-auto" data-id="element-383">
          {/* Photo - Shows first on mobile, left on desktop */}
          <motion.div className="order-1" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-384">
            <div className="relative" data-id="element-385">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl" data-id="element-386">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5gzTFgtsYUBAhaD6tWDvz7/Peter_and_Jake.jpg" alt="Peter & Jake Swenson" className="w-full h-full object-cover" data-id="element-387" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-mint rounded-xl p-6 shadow-xl" data-id="element-388">
                <div className="text-deep-blue text-center" data-id="element-389">
                  <div className="text-3xl font-bold" data-id="element-390">200K+</div>
                  <div className="text-sm font-semibold" data-id="element-391">Doors Knocked</div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Content - Shows second on mobile, right on desktop */}
          <motion.div className="order-2" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          ease: [0.25, 0.1, 0.25, 1],
          delay: 0.2
        }} data-id="element-392">
            <h2 className="mb-6" data-id="element-393">Peter & Jake Swenson</h2>
            <div className="space-y-6 leading-relaxed" data-id="element-394">
              <p data-id="element-395">
                Peter and Jake Swenson bring more than 40 years of combined
                experience in the door-to-door space. They started in 2005, and
                for 15 years, they did it the hard way – hiring, training, and
                managing over 2,000 reps manually. They lived the daily grind of
                inconsistent recruiting and leadership burnout.
              </p>
              <p data-id="element-396">
                In 2020, they decided to stop guessing. They began engineering
                The HIRE Advantage system, spending the next four years
                (2021–2024) refining it in the trenches.
              </p>
              <p className="font-semibold text-deep-blue" data-id="element-397">
                The result? The system recruited another 2,000 reps. That rookie
                talent generated over $100M in sales production (contributing to
                over $130M in total organizational revenue).
              </p>
              <div className="bg-gray-50 rounded-lg p-6 border-l-4 border-mint" data-id="element-398">
                <p className="font-semibold text-deep-blue mb-3" data-id="element-399">
                  It was through that deep experience that they realized the
                  rest of the industry had a massive problem:
                </p>
                <ul className="space-y-2" data-id="element-400">
                  <li data-id="element-401">• Most companies were just "hiring bodies."</li>
                  <li data-id="element-402">• Reps were slipping through the cracks.</li>
                  <li data-id="element-403">• Leaders were burning out.</li>
                  <li data-id="element-404">• Rookies were quitting because they had no support.</li>
                </ul>
              </div>
              <p data-id="element-405">
                <span className="font-bold text-deep-blue" data-id="element-406">
                  Now, they install that same system for other high-growth
                  teams.
                </span>
              </p>
              <p data-id="element-407">
                It's not just about hiring people – it's about building a
                framework where they can actually succeed.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}